export default __webpack_public_path__ + "static/media/arrowDown.5adb884e.svg";